<template>
    <div class="run">
        <div class="title">
            <div class="tabType">
                <span :class="typeIdx == 0? 'se':''" @click="tabType(0)">运行分析</span>
                <span :class="typeIdx == 1? 'se':''" @click="tabType(1)">历史曲线</span>
            </div>
            <div class="tabDate">
                <span :class="dateIdx == 0? 'sed':''" @click="tabDate(0)">日</span>
                <span :class="dateIdx == 1? 'sed':''" @click="tabDate(1)">月</span>
                <span :class="dateIdx == 2? 'sed':''" @click="tabDate(2)">年</span>
            </div>
        </div>
        <div class="content">
            <div class="runanalysis" v-show="typeIdx == 0">
                <div class="load">
                    <h1><img src="../../../assets/img/warning.png" alt=""> 平均负载偏低</h1>
                    <p>危害：</p>
                    <p>1. 变压器效率低下，不利于节能;</p>
                    <p>2. 功率因数低导致多交力调电费。</p>
                    <p>建议：</p>
                    <p>1. 调节运行方式，合理规划用电负荷。</p>
                </div>
                <div class="minload">
                    <div class="item">
                        <p>最小负载</p>
                        <p :class="workload.min == '--'? 'grey':''">{{workload.min}} <span v-show="workload.min !== '--'">kVA</span></p>
                    </div>
                    <div class="item">
                        <p>最小负载率</p>
                        <p :class="workload.minLoadFactor == '--'? 'grey':''">{{workload.minLoadFactor}} <span v-show="workload.minLoadFactor !== '--'">%</span></p>
                    </div>
                    <div class="item">
                        <p>记录时间</p>
                        <p>{{workload.minTime}}</p>
                    </div>
                </div>
                <div class="minload">
                    <div class="item">
                        <p>最大负载</p>
                        <p :class="workload.max == '--'? 'grey':''">{{workload.max}} <span v-show="workload.max !== '--'">kVA</span></p>
                    </div>
                    <div class="item">
                        <p>最大负载率</p>
                        <p :class="workload.maxLoadFactor == '--'? 'grey':''">{{workload.maxLoadFactor}} <span v-show="workload.maxLoadFactor !== '--'">%</span></p>
                    </div>
                    <div class="item">
                        <p>记录时间</p>
                        <p >{{workload.maxTime}}</p>
                    </div>
                </div>
                <div class="minload">
                    <div class="item">
                        <p>平均负载</p>
                        <p :class="workload.mean == '--'? 'grey':''">{{workload.mean}} <span v-show="workload.mean !== '--'">kVA</span></p>
                    </div>
                    <div class="item">
                        <p>平均负载率</p>
                        <p :class="workload.meanLoadFactor == '--'? 'grey':''">{{workload.meanLoadFactor}} <span v-show="workload.meanLoadFactor !== '--'">%</span></p>
                    </div>
                </div>
            </div>
            <div class="historyChart" v-show="typeIdx == 1">
                <div class="chartsDiargm">
                    <div :class="!checked? 'left full':'left'">
                        <div class="timeSe">
                            <TimeSelect ref="timeSelect" @sendTime="sendTime"/>
                        </div>
                        <div class="chart">
                            <!-- <Charts  id="historyDiagram" :option="options" v-if="isfull && Object.keys(points).length > 0"/> -->
                            <Charts  id="historyDiagram" v-if="isfull" :option="options" />
                        </div>
                    </div>
                    <div :class="!checked? 'right nofull':'right' ">
                        <div class="itemVal" v-for="(val, key) in extreme" :key="key">
                            <div class="name">{{extreme[key].type}}</div>
                            <div class="extreme">
                                <p >最大值 <span :class="extreme[key].max == '--'?'grey':''">{{extreme[key].max + ' ' +extreme[key].unit}}</span></p>
                                <p >最小值 <span :class="extreme[key].min == '--'?'grey':''">{{extreme[key].min + ' ' +extreme[key].unit}}</span></p>
                                <p >平均值 <span :class="extreme[key].mean == '--'?'grey':''">{{extreme[key].mean + ' ' +extreme[key].unit}}</span></p>
                            </div>
                        </div>
                    </div>
                    <el-checkbox v-model="checked" @change="showEXval">最值分析</el-checkbox>
                    <!-- <img src="../../../assets/img/not_found_data.png" alt="" v-if="Object.keys(points).length == 0"> -->
                </div>
            </div>
        </div>
    </div>
</template>

<script>
const TimeSelect = ()=>import('./TimeSelect.vue')
const Charts  = ()=>import('../../../components/common/Charts.vue')
import { getTransformerWorkload, getLoadCharts } from '../../../api/power'
export default { 
    props:['transformer'],
    data(){
        return {
            typeIdx:0,
            dateIdx:0,
            result:{},
            currentTime:'',
            points:{
                'P':[],
                'Temperature_A':[],
                'Temperature_B':[],
                'Temperature_C':[]
            },
            xData:[],
            checked:true,
            isfull:true,
            timer:null
        }
    },
    components:{
        TimeSelect, Charts
    },
    computed:{
        options(){
            if(this.typeIdx==1){
                return {
                    xAxis: {
                        type: 'category',
                        data: this.xData,
                        splitLine:{
                            show:true
                        },
                        axisTick:{
                            alignWithLabel:true
                        },
                        axisLabel:{
                            fontSize:12,
                            fontWeight:'bold'
                        }
                    },
                    color:['#0D94FF', '#F6BD16', '#5AD8A6', '#E8684A'],
                    yAxis: [
                        {
                            name:'%',
                            nameTextStyle:{
                                fontStyle:'italic',
                                fontWeight:'bold',
                                fontSize:14,
                                align:'right' 
                            },
                            type: 'value',
                            position: 'left',
                            alignTicks: true,
                            // axisLabel:{
                            //     formatter:function(value, index){
                            //         return value + '%'
                            //     }
                            // }
                            axisLabel:{
                                fontSize:12,
                                fontWeight:'bold'
                            },
                            max:100,
                            min:0
                        },
                        {
                            name:'℃',
                            nameTextStyle:{
                                fontStyle:'italic',
                                fontWeight:'bold',
                                fontSize:14,
                                align:'left'  
                            },
                            type: 'value',
                            position: 'right',
                            max:100,
                            min:0,
                            // axisLabel:{
                            //     formatter:function(value, index){
                            //         return value + ''
                            //     }
                            // }
                            axisLabel:{
                                fontSize:12,
                                fontWeight:'bold'
                            }
                        },
                    ],
                    tooltip: {
                        trigger: 'axis',
                            axisPointer: {
                            type: 'shadow'
                        },
                        formatter: function (params) {
                            let str = `${params[0].name}<br/>`;
                            params.forEach((item, idx) => {
                                str += `${item.marker}${item.seriesName}： <b style='font-size:18px;'>${item.value}</b><b style='font-size:14px;'> ${item.seriesName == '负载率'?'%':'℃'}</b>`;
                                str += idx === params.length -1? '': '<br/>'
                            })
                            return str
                        },
                    },
                    legend: {
                        icon:'square',
                        top:'0px'
                    },
                    series: [ 
                        {
                            name: '负载率',
                            data: this.points['P'],
                            markPoint: {
                                symbol:this.checked? 'pin':'none',
                                symbolSize:20,
                                data: [
                                    { type: 'max', name: 'Max' },
                                    { type: 'min', name: 'Min' }
                                ],
                                label:{
                                    position:'top'
                                }
                            },
                            type: 'line',
                            yAxisIndex:0
                        },
                        {
                            name: 'A相温度',
                            data: this.points['Temperature_A'],
                            type: 'line',
                            yAxisIndex:1,
                            markPoint: {
                                symbol:this.checked? 'pin':'none',
                                symbolSize:20,
                                data: [
                                    { type: 'max', name: 'Max' },
                                    { type: 'min', name: 'Min' }
                                ],
                                label:{
                                    position:'top'
                                }
                            },
                        },
                        {
                            name: 'B相温度',
                            data: this.points['Temperature_B'],
                            type: 'line',
                            yAxisIndex:1,
                            markPoint: {
                                symbol:this.checked? 'pin':'none',
                                symbolSize:20,
                                data: [
                                    { type: 'max', name: 'Max' },
                                    { type: 'min', name: 'Min' }
                                ],
                                label:{
                                    position:'top'
                                }
                            },
                        },
                        {
                            name: 'C相温度',
                            data: this.points['Temperature_C'],
                            type: 'line',
                            yAxisIndex:1,
                            markPoint: {
                                symbol:this.checked? 'pin':'none',
                                symbolSize:20,
                                data: [
                                    { type: 'max', name: 'Max' },
                                    { type: 'min', name: 'Min' }
                                ],
                                label:{
                                    position:'top'
                                }
                            },
                        },
                        
                    ],
                    grid: {
                        left: "0%",
                        right: "0%",
                        bottom: "0%",
                        top: "17%",
                        containLabel: true,
                    },
                }
            }else{
                return {}
            }
            
        },
        workload(){
            let obj = {}
            let result = this.result
            if(Object.keys(result).length >0){
                let capacity = parseInt(JSON.parse(this.transformer.device_details)['电气']['容量'])
                let arr = ['', 'month', 'year']
                
                // console.log(result);
                // console.log(result[arr[this.dateIdx]  + 'min']);
                obj = {
                    min:result[arr[this.dateIdx] + 'mintime'] ?(result[arr[this.dateIdx]  + 'min']  / 1000).toFixed(2):'--',
                    minTime:result[arr[this.dateIdx] + 'mintime']?result[arr[this.dateIdx] + 'mintime'].substr(0, 18).replace('T', ' '):'--',
                    minLoadFactor:result[arr[this.dateIdx] + 'mintime']?(result[arr[this.dateIdx]  + 'min']  / 10 / capacity).toFixed(2):'--',
                    mean:result[arr[this.dateIdx] + 'meantime']?(result[arr[this.dateIdx] + 'mean'] / 1000).toFixed(2):'--',
                    meanTime:result[arr[this.dateIdx] + 'meantime']?result[arr[this.dateIdx] + 'meantime'].substr(0, 18).replace('T', ' '):'--',
                    meanLoadFactor:result[arr[this.dateIdx] + 'meantime']?(result[arr[this.dateIdx] + 'mean'] / 10 / capacity).toFixed(2):'--',
                    max:result[arr[this.dateIdx] + 'maxtime']?(result[arr[this.dateIdx] + 'max'] / 1000).toFixed(2):'--',
                    maxTime:result[arr[this.dateIdx] + 'maxtime']?result[arr[this.dateIdx] + 'maxtime'].substr(0, 18).replace('T', ' '):'--',
                    maxLoadFactor:result[arr[this.dateIdx] + 'maxtime']?(result[arr[this.dateIdx] + 'max'] / 10 / capacity).toFixed(2):'--'
                }
                return obj
            }else{
                return {
                    min:'--',
                    minTime:'--',
                    minLoadFactor:'--' ,
                    mean:'--',
                    meanTime:'--',
                    meanLoadFactor:'--',
                    max:'--',
                    maxTime:'--',
                    maxLoadFactor:'--'
                }
            }
            
        },
        extreme(){
            let obj = {}
            // console.log(this.points);
            
            for(let key in this.points){
                let arr = this.points[key].filter(item =>item !=='').sort((a,b)=>{
                    return a - b
                })
                
                if(arr.length > 0){
                    let obj2 = {
                        min:Number(arr[0]).toFixed(2),
                        max:Number(arr[arr.length - 1]).toFixed(2),
                        mean:mean(arr),
                        type:key == 'P'?'负载率':key == 'Temperature_A'?'A相':key == 'Temperature_B'?'B相':'C相',
                        unit:key == 'P'?'%':'℃',
                    }
                    obj[key] = obj2
                }else{
                    
                    let obj3 = {
                        min:'--',
                        max:'--',
                        mean:'--',
                        type:key == 'P'?'负载率':key == 'Temperature_A'?'A相':key == 'Temperature_B'?'B相':'C相',
                        unit:key == 'P'?'%':'℃',
                    }
                    obj[key] = obj3
                }
                
            }

            function mean(arr){
                let sum = 0
                arr.forEach(item =>{
                    sum += Number(item)
                })
                return (sum / arr.length).toFixed(2)
            }
            
            return obj 
        }
    },
    watch:{
        currentTime(val){
            let _this = this
            // return
            switch(this.dateIdx){
                case 0:
                    _this.getLoadChart({
                        time:val,
                        group:'1h'
                    })
                    break;
                case 1:
                    _this.getLoadChart({
                        time:val,
                        group:'1d'
                    })
                    break;
                case 2:
                    _this.getLoadChart({
                        time:val,
                        group:'1M'
                    })
                    break;
            }
        },
        dateIdx(val){
            let _this = this
            if(this.typeIdx == 0) return
            switch(val){
                case 0:
                    _this.getLoadChart({
                        time:_this.currentTime,
                        group:'1h'
                    })
                    break;
                case 1:
                    _this.getLoadChart({
                        time:_this.currentTime,
                        group:'1d'
                    })
                    break;
                case 2:
                    _this.getLoadChart({
                        time:_this.currentTime,
                        group:'1M'
                    })
                    break;
            }
        },
        'transformer.loop_id'(val){
            // console.log(val);
            this.getWorkload()
            this.getData()
        },
        typeIdx(n,o){
            if(this.$refs.timeSelect){
                let arr = ['day', 'month', 'year']
                this.$refs.timeSelect.radio = arr[this.dateIdx]
            }
        }
    },
    mounted(){
        let _this = this
        if(this.transformer){
            this.getWorkload()
        }
        this.xData =  this.getTimeAxis('day')
        this.timer = setInterval(()=>{
			_this.getData()
		}, 3600 * 1000)
    },
    destroyed(){
        
		if(this.timer){
			clearInterval(this.timer)
			this.timer = null
		}
        
	},
    methods:{
        getData(){
            let _this = this
            if(_this.typeIdx == 0) return
            switch(_this.dateIdx){
                case 0:
                    _this.getLoadChart({
                        time:_this.currentTime,
                        group:'1h'
                    })
                    break;
                case 1:
                    _this.getLoadChart({
                        time:_this.currentTime,
                        group:'1d'
                    })
                    break;
                case 2:
                    _this.getLoadChart({
                        time:_this.currentTime,
                        group:'1M'
                    })
                    break;
            }
        },
        tabType(idx){
            this.typeIdx = idx
        },
        tabDate(idx){
            this.dateIdx = idx
            if(this.$refs.timeSelect){
                let arr = ['day', 'month', 'year']
                this.$refs.timeSelect.radio = arr[idx]
            }
        },
        async getWorkload(){
            let res = await getTransformerWorkload({
                deviceLoop:this.transformer.loopId,
                projectId:this.$store.getters.projectId
            })
            if(res.data.code == 200){
                this.result = res.data.data.influxData.data.res
                // console.log(this.result);
                this.tabDate(0)
            }else{
                // console.log(res.data.errMsg);
            }
        },
        sendTime(time){
            this.currentTime = time
        },
        async getLoadChart(option){
            this.points = {
                'P':[],
                'Temperature_A':[],
                'Temperature_B':[],
                'Temperature_C':[]
            }
            let {
                time,
                group = "1h"
            } = option
            let _this = this
            let times = this.getTimeAxis(time)
            let hour = new Date().getHours() + 1
            
            let timeStartEnd = this.getStartEnd(time, times.length)
            this.xData = times

            // this.points = {}
            let res = await getLoadCharts({
                deviceLoopId:this.transformer.loopId,
                start :timeStartEnd.start,
                end:timeStartEnd.end,
                group,
                node:'Temperature_A,Temperature_B,Temperature_C,P'
            })
            
            
            if(res.data.code == 200){
                let points = res.data.data.points

                for(let key in points){
                    if(key == 'P'){
                        
                        let arr = new Array(times.length).fill('')
                        points[key].forEach((item,index) =>{
                            
                            let val = item.val == ''?'':item.val / 10 / parseInt(JSON.parse(this.transformer.device_details)['电气']['容量'])
                            
                            arr[index] = val == ''?'': Number(val).toFixed(2)
                            
                        })
                        this.points[key] = arr
                    }else{

                        let arr = new Array(times.length).fill('')
                        points[key].forEach((item,index) =>{
                            let val = item.val 
                            arr[index] = val == ''?'': Number(val).toFixed(2)
                        })
                        this.points[key] = arr
                    }
                    
                }
                // this.points = points
            }else{
                // console.log(res.data.errMsg);
            }
        },
        getTimeAxis(time){
            let xData = []
            switch(this.dateIdx){
                case 0:
                    for(let i = 0;i <=24;i++){
                        xData[i] = `${i}点`
                    }
                    break;
                case 1:
                    let arr = time.split('-')
                    let days = new Date(arr[0], arr[0], 0).getDate()
                    for(let i = 0;i <days;i++){
                        xData[i] = `${i + 1}日`
                    }
                    break;
                case 2:
                    for(let i = 0;i <12;i++){
                        xData[i] = `${i + 1}月`
                    }
                    break;
            }
            return xData
        },
        getStartEnd(time, days){
            let start = ''
            let end = ''
            switch(this.dateIdx){
                case 0:
                    start = `${time}T00:00:00Z`,
                    end = `${time}T24:00:00Z`
                    break;
                case 1:
                    start = `${time.split('-')[0]}-${time.split('-')[1]}-01T00:00:00Z`,
                    end = `${time.split('-')[0]}-${time.split('-')[1]}-${days}T00:00:00Z`
                    break;
                case 2:
                    start = `${time.split('-')[0]}-01-01T00:00:00Z`,
                    end = `${time.split('-')[0]}-12-21T00:00:00Z`
                    break;
            }
            return {
                start,end
            }
        },
        showEXval(val){
            console.log(val);

            this.isfull = false
            this.$nextTick(()=>{
                this.isfull = true
            })
        }
    }
}
</script>

<style lang="less" scoped>
    .run{
        padding-top: 1.4vh;
        .title{
            height: 3.2vh;
            display: flex;
            justify-content: space-between;
            align-items: center;
            border-bottom: 1px solid rgba(0, 0, 0, 0.15);
            .tabType{
                &>span{
                    display: inline-block;
                    padding-left: 0.7vw;
                    margin-right: 1vw;
                    font-size: 18rem;
                    font-family: Source Han Sans CN;
                    font-weight: bold;
                    color: #333333;
                    position: relative;
                    cursor: pointer;
                    &::before{
                        content:'';
                        width: 0.3vw;
                        height: 2vh;
                        background-color:none;
                        position: absolute;
                        top: 50%;
                        left: 0;
                        transform: translate(0, -50%);
                    }
                }
                .se{
                    color: #0D94FF;
                    &::before{
                        background-color: #0D94FF;
                    }
                }
            }

            .tabDate{
                padding-right: 1vw;
                &>span{
                    font-size: 16rem;
                    font-family: Source Han Sans CN;
                    font-weight: bold;
                    color: #000;
                    position: relative;
                    margin-left: 57px;
                    cursor: pointer;
                    &::before{
                        content:'';
                        width: 40px;
                        height: 2px;
                        background-color:none;
                        position: absolute;
                        bottom: 150%;
                        left: 50%;
                        transform: translate(-50%, -50%);
                    }
                }
                .sed{
                    color: #0D94FF;
                    &::before{
                        background-color: #0D94FF;
                    }
                }
            }
        }

        .content{
            height: 32vh;
            width: 100%;
            
            .runanalysis{
                width: 100%;
                height: 100%;
                display: flex;
                justify-content: space-between;
                align-items: flex-start;
                padding-top:2vh ;
                .load{
                    width: 30%;
                    height: 26vh;
                    background: rgba(0, 0, 0, 0.04);
                    border-radius: 5rem;
                    padding: 0 1vw;
                    &>h1{
                        height:8.5vh ;
                        line-height: 8.5vh;
                        font-size: 24rem;
                        font-family: Source Han Sans CN;
                        font-weight: bold;
                        color: #F5AA00;
                        &>img{
                            width: 24rem;
                            height: 24rem;
                            vertical-align: middle;
                            margin-top: -5rem;
                        }
                    }
                    &>p{
                        font-size: 16rem;
                        font-family: Source Han Sans CN;
                        font-weight: bold;
                        color: #333333;
                        padding-bottom: 0.5vh;
                    }
                }

                .minload{
                    width: 22%;
                    height: 26vh;
                    background: rgba(0, 0, 0, 0.04);
                    border-radius: 5rem;
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    .item{
                        margin-top:3.5vh ;
                        width: 100%;
                        text-align: center;
                        &>p:nth-child(1){
                            font-size: 18rem;
                            font-family: Source Han Sans CN;
                            font-weight: bold;
                            color: #333333;
                        }
                        &>p:nth-child(2){
                            font-size: 24rem;
                            font-family: Source Han Sans CN;
                            font-weight: bold;
                            color: #0D94FF;
                        } 
                    }
                    .item:nth-child(3){
                        margin-top:2vh ;
                        &>p:nth-child(1){
                            font-size: 16rem;
                            color: #999;
                        }
                        &>p:nth-child(2){
                            font-size: 16rem;
                            color: #999;
                        } 
                    }
                }

                
            }
            .historyChart{
                height: 100%;
                
                .chartsDiargm{
                    height: 100%;
                    display: flex;
                    justify-content: space-between;
                    position: relative;
                    &>img{
                        position: absolute;
                        top: 58%;
                        left: 50%;
                        transform: translate(-50%, -50%);
                    }
                    .el-checkbox{
                        position: absolute;
                        top: 2vh;
                        right: 39%;
                    }
                    .left{
                        width: 78%;
                        height: 100%;
                        .timeSe{
                            height: 5vh;
                        }
                        .chart{
                            height: calc(100% - 5vh);
                        }
                    }
                    .full{
                        width: 100%;
                    }
                    
                    .right{
                        width: 20%;
                        height: 100%;
                        display: flex;
                        flex-direction: column;
                        justify-content: space-between;
                        
                        .itemVal{
                            width: 100%;
                            height: 7.5vh;
                            background: #F5F7F9;
                            display: flex;
                            padding: 0 9px;
                            justify-content: space-between;
                            align-items: center;
                            .name{
                                font-size: 14rem;
                                font-family: Source Han Sans CN;
                                font-weight: bold;
                                color: #333333;
                            }
                            .extreme{
                                &>p{
                                    font-size: 14rem;
                                    font-family: Source Han Sans CN;
                                    font-weight: 400;
                                    color: #333333;
                                    &>span{
                                        font-size: 14rem;
                                        font-weight: bold;
                                        color: #0D94FF;
                                        padding-left: 0.3vw;
                                    }
                                }
                            }
                        }
                    }
                    .nofull{
                        width: 0%;
                        display: none;
                    }
                }
            }
        }
    }
</style>